/**
 * @file Anything that can run on every page
 */

import vSupportForm from '../components/support-form/support-form';

jQuery.noConflict();
( function( $ ) {
	/*
	-------------------------------------
	FUNCTIONS
	-------------------------------------
	*/
	vSupportForm();
	/*
	-------------------------------------
	DOCUMENT READY
	-------------------------------------
	*/

	$( document ).ready( function() {
		/*
		-------------------------------------
		SHOP DROPDOWN
		-------------------------------------
		*/

		$( 'ul.shop-pages' ).hide();

		$( 'li.page-item-10' ).mouseenter( function() {
			$( 'ul.shop-pages' ).slideDown( 300 );
		} );

		$( 'ul.shop-pages' ).mouseleave( function() {
			$( 'ul.shop-pages' ).slideUp( 300 );
		} );

		$( 'li.page-item-12, li.page-item-14, li.page-item-16, .logo, #banner, #wrapper' ).mouseenter( function() {
			$( 'ul.shop-pages' ).slideUp( 300 );
		} );

		/*
		-------------------------------------
		HAMBURGER & MOBILE NAV
		-------------------------------------
		*/
		let mobileStatus =  false;
		$( '#hamburger' ).click( function() {
			$( this ).toggleClass( 'open' );
			$( '.mobile-nav' ).toggleClass( 'open' );
			$( '.mobile-nav ul' ).toggleClass( 'open' );
			$( '.sp-cart' ).toggleClass( 'open' );
			$( 'body' ).toggleClass( 'menu-open' );

			if ( mobileStatus === false ) {
				document.ontouchmove = function( e ) {
					// disable mobile scrolling
					e.preventDefault();
				};
				mobileStatus         = true;
			} else {
				document.ontouchmove = function() {
					// enable mobile scrolling
					return true;
				};
				mobileStatus         = false;
			}
		} );

		$( '.mobile-nav-items ul.children' ).hide();

		$( '.mobile-nav-items ul li.page-item-10 > a' ).on( 'touchend', function( e ) {
			e.preventDefault();
			$( '.mobile-nav-items ul.children' ).slideToggle( 200 );
		} );

		/*
		-------------------------------------
		SEARCH
		-------------------------------------
		*/

		$( '#wrapper.search' ).hide();

		$( '.search-header' ).click( function() {
			$( '#wrapper.search' ).slideToggle( 300 );
		} );

		/*
		-------------------------------------
		SUBMIT BUTTONS
		-------------------------------------
		*/

		$( 'form#search-form #header-search-submit' ).click( function() {
			$( this ).closest( 'form#search-form' ).submit();
		} );

		$( 'form#search-form #mobile-search-submit' ).click( function() {
			$( this ).closest( 'form#search-form' ).submit();
		} );

		$( 'form#search-form #footer-search-submit' ).click( function() {
			$( this ).closest( 'form#search-form' ).submit();
		} );
	} );

	$( document ).on( 'facetwp-loaded', function() {
		setTimeout( function() {
			$( '.items .item' ).matchHeight();
		}, 500 );
	} );
}( jQuery ) );
